export type TurnstileRenderOptions = {
	sitekey: string;
	action: string;
	size: 'normal' | 'compact' | 'flexible';
	appearance?: 'always' | 'execute' | 'interaction-only';
	callback: (token: string) => void;
	'before-interactive-callback'?: () => void;
	'after-interactive-callback'?: () => void;
	'error-callback': (errorCode?: string) => boolean | void;
	'expired-callback': () => void;
	'timeout-callback'?: () => void;
};

export type TurnstileApi = {
	render: (container: HTMLElement, options: TurnstileRenderOptions) => string;
	execute: (widgetId: string) => void;
	reset: (widgetId?: string) => void;
	remove: (widgetId: string) => void;
};

let loadPromise: Promise<TurnstileApi> | null = null;

/** Loads the explicit-render API once, while allowing a user-triggered retry after a network failure. */
export function loadTurnstile(): Promise<TurnstileApi> {
	if (window.turnstile) return Promise.resolve(window.turnstile);
	if (loadPromise) return loadPromise;
	loadPromise = new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
		script.async = true;
		script.defer = true;
		script.onload = () => {
			if (window.turnstile) resolve(window.turnstile);
			else {
				loadPromise = null;
				reject(new Error('turnstile_api_unavailable'));
			}
		};
		script.onerror = () => {
			loadPromise = null;
			reject(new Error('turnstile_script_failed'));
		};
		document.head.appendChild(script);
	});
	return loadPromise;
}

declare global {
	interface Window {
		turnstile?: TurnstileApi;
	}
}
